import loadable from "@loadable/component";

const Home = loadable(() => import("./components/home/elements/home"));
const AgenticFraudManagement = loadable(() =>
	import("./components/agentic-fraud-management/elements/agentic-fraud-management")
);

const routes = [
	{ path: "/", exact: true, name: "home", component: Home, title: "karega.com" },
	{
		path: "/agentic-fraud-management",
		exact: true,
		name: "agentic-fraud-management",
		component: AgenticFraudManagement,
		title: "Agentic AI for Fraud Management",
	},
];

export default routes;
